// Module
var code = "<template>\r\n    <slot></slot>\r\n</template>";
// Exports
export default code;